import type {InnerBlock} from 'quickstart/types'
import {
  BaseGlobalStyle,
  CssModulesGlobalStyle,
  LinariaGlobalStyle,
  StyledComponentsGlobalStyle,
} from './globalStyles'

export const ThemeBlock: InnerBlock<undefined> = () => (
  <>
    <BaseGlobalStyle />
    <CssModulesGlobalStyle />
    <LinariaGlobalStyle />
    <StyledComponentsGlobalStyle />
  </>
)
